<template>
  <v-menu ref="menuOpen" v-model="menuOpen" :close-on-content-click="!range" transition="scale-transition" offset-y min-width="auto">
    <template v-slot:activator="{ on, attrs }">

      <VTextField :value="value" :label="label" readonly v-bind="attrs" v-on="on" dense outlined hide-details :disabled="disabled" :loading="loading">
        <v-icon slot="append" color="error" v-if="value" @click="$emit('input',null)" :disabled="disabled">close</v-icon>
        <v-icon slot="prepend-inner">{{calendarIcon}}</v-icon>
      </VTextField>

    </template>
    <VDatePicker :value="value" @input="changeVal" :min="min" :max="max" :range="range" />
  </v-menu>
</template>

<script>
  import { mdiCalendarBlank } from '@mdi/js';

  export default {

    props: {

      range: {
        type: Boolean,
        default: false
      },

      value: {
        type: [String,Array],
        default: ''
      },

      disabled: {
        type: Boolean,
        default: false
      },

      loading: {
        type: Boolean,
        default: false
      },

      label: {
        type: String,
        default: 'Date select'
      },

      min: {
        type: String,
        default: ''
      },

      max: {
        type: String,
        default: ''
      },

    },

    data() {
      return {
        calendarIcon: mdiCalendarBlank,
        menuOpen: false,
      }
    },

    methods: {
      changeVal(val) {
        this.$emit('input',val);
      }
    },

  }
</script>

<style lang="scss" scoped>

</style>
